import { Dialog } from "@mui/material";
import { StopNew } from "../../../ducks/data/route-with-stops/types";
import {
  StopDriverArrived,
  StopDriverDeparted,
} from "../../SessionsPage/StopPage/StopDriverArrivedDeparted";
import { useSelector } from "react-redux";
import {
  selectDriverCanDeleteCargo,
  selectDriverDeleteStopIsDisabled,
  selectShouldShowArrivalDepartureButtonsNew,
} from "../../../ducks/data/route-with-stops/selectors";
import { selectShouldShowCompleteStopButton } from "../../../ducks/auth/selectors";
import { PickupDropoffButton } from "../../SessionsPage/StopPage/StopCompleted";
import AddImage from "../../SessionsPage/StopPage/AddImage";
import AddCubicMetersModalAndButton from "../../SessionsPage/modals/AddCubicMetersModalAndButton";
import AddCommentModalAndButton from "../../SessionsPage/modals/AddCommentModalAndButton";
import AddWeightModalAndButton from "../../SessionsPage/modals/AddWeightModalAndButton";
import AddRefModalAndButton from "../../SessionsPage/modals/AddRefModalAndButton";
import Button from "@mui/material/Button";
import { useMemo, useState } from "react";
import EditAddressDialog from "../../SessionsPage/StopPage/edit-dialogs/EditAddressDialog";
import { useRoutePageContext } from "../RoutePageContext";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import AddScan from "../../SessionsPage/StopPage/AddScan";
import useFeature from "../../../hooks/useFeature";
import { isMobile } from "../../../helpers/mobile";
import DeleteStopModalAndButton from "../StopComponents/DeleteStopModalAndButton";

const EditDriverCreatedCargoStopDialog = ({
  stop,
  onClose,
  cargoInvoiceRef,
}: {
  stop: StopNew;
  onClose: () => void;
  cargoInvoiceRef: string | null;
}) => {
  const documentScanEnabled = useFeature("mobile-document-scan");
  const [shouldShowEditAddressDialog, setShouldShowEditAddressDialog] =
    useState(false);
  const shouldShowArrivalDepartureButtons = useSelector(
    selectShouldShowArrivalDepartureButtonsNew(stop.id)
  );
  const shouldShowCompleteStopButton = useSelector(
    selectShouldShowCompleteStopButton
  );
  // const truckId = useAppSelector(selectCurrentTruckId);
  const driverCanDeleteCargo = useSelector(
    selectDriverCanDeleteCargo(stop.cargoId)
  );
  const deleteStopButtonDisabled = useSelector(
    selectDriverDeleteStopIsDisabled(stop.id)
  );

  const { t } = useTranslation(["stopPage"]);

  const podNumberForStop = stop.attachments.filter(
    (a) => a.documentType === "POD"
  ).length;

  const stopAddress = useMemo(() => {
    return [
      stop.place.placeName,
      stop.place.address,
      stop.place.postcode,
      stop.place.city,
    ]
      .filter(Boolean)
      .join(", ");
  }, [stop]);

  const { reloadData } = useRoutePageContext();

  return (
    <Dialog open onClose={onClose}>
      {shouldShowEditAddressDialog && (
        <EditAddressDialog
          cargoId={stop.cargoId}
          stopId={stop.id}
          onClose={() => {
            reloadData();
            setShouldShowEditAddressDialog(false);
          }}
        />
      )}
      <div className="relative p-6">
        <div style={{ top: 12, right: 12, position: "absolute" }}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div>{t("stopPage:editStop")}</div>
        <div className="flex flex-col gap-2 mt-4">
          <Button
            variant="contained"
            onClick={() => setShouldShowEditAddressDialog(true)}
          >
            {stopAddress}
          </Button>
          {shouldShowArrivalDepartureButtons && (
            <div className="flex gap-2 items-center justify-between">
              <StopDriverArrived stop={stop} />
              <StopDriverDeparted stop={stop} />
            </div>
          )}
          {shouldShowCompleteStopButton && <PickupDropoffButton stop={stop} />}
          {documentScanEnabled && isMobile && (
            <AddScan
              cargoId={stop.cargoId}
              stopId={stop.id}
              // scanCount={podNumberForStop}
              onSuccess={reloadData}
            />
          )}
          <AddImage
            cargoId={stop.cargoId}
            stopId={stop.id}
            added={!!podNumberForStop}
            imagesForStop={podNumberForStop}
            onSuccess={reloadData}
          />
          <AddCommentModalAndButton stop={stop} />
          <AddWeightModalAndButton stop={stop} />
          <AddCubicMetersModalAndButton stop={stop} />
          <AddRefModalAndButton stop={stop} cargoInvoiceRef={cargoInvoiceRef} />
          {driverCanDeleteCargo && (
            <>
              <DeleteStopModalAndButton
                onDeleteSuccessful={onClose}
                disabled={deleteStopButtonDisabled}
                stop={stop}
              />
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default EditDriverCreatedCargoStopDialog;
